module.exports = __webpack_public_path__ + "static/arrow-right-5f0ed638fcffdf0d82519f3a8e7a4652.png";